// extracted by mini-css-extract-plugin
module.exports = {"triangle":"triangle--35Il9","text":"text--VYOFK"};